import styled, { css } from 'styled-components';
import { breakpoints } from '@theme/breakpoints';

import CheckIcon from '@public/icons/Check-3.svg';

export const StyledBundleProducts = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: Geomanist, sans-serif;
  text-align: center;
  margin: 5rem auto;

  & h2 {
    font-weight: 500;
    font-size: 20px;
    line-height: 100%;
    text-align: center;
    color: var(--color-primary);
    margin-bottom: 1rem;

    @media ${breakpoints.tablet} {
      font-size: 26px;
    }

    @media ${breakpoints.desktop} {
      font-size: 34px;
    }
  }

  .subtitle {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    max-width: 100%;

    @media ${breakpoints.tablet} {
      font-size: 18px;
    }

    @media ${breakpoints.desktop} {
      font-size: 20px;
      max-width: 80%;
    }
    & p {
      margin-bottom: 2rem;
    }
  }
`;

export const BundleProductsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 2rem;
  gap: 6rem;
  align-items: center;

  @media ${breakpoints.tablet} {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }
`;

function isSelectedStyle({ $isSelected = false }) {
  if ($isSelected) {
    return css`
      @media ${breakpoints.desktopLarge} {
        transform: scale(1.05);
      }
      border: blue 4px solid;
      border-radius: 0.5rem;
    `;
  }
}

export const StyledBundleProductCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #f8f9ff;
  border-radius: 8px;
  width: 100%;
  position: relative;
  cursor: pointer;
  ${isSelectedStyle}

  @media ${breakpoints.desktopLarge} {
    &:hover {
      transform: scale(1.025);
      transition: all 0.2s ease-in-out;
    }
  }

  @media ${breakpoints.mobilelg} {
    width: 410px;
  }

  & .card-header {
    background-image: linear-gradient(135deg, #0000ff 0%, #0000ff 45%, #f4111b 100%);
    background-color: #0000ff;
    padding: 2.5rem 0.8rem 0.2rem 0.8rem;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: ${({ $isSelected }) => ($isSelected ? '0' : '0.5rem 0.5rem 0 0')};
    overflow: hidden;
    height: 275px;
  }

  & h3 {
    font-family: Geomanist, sans-serif;
    font-weight: 700;
    font-size: 34px;
    line-height: 34px;
    text-align: center;
    color: #fff;
    margin-bottom: 0.7rem;
  }

  & .bundle-price {
    font-family: Geomanist, sans-serif;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: 0.7rem;
    font-weight: 200;
    font-size: 25px;
  }

  & .bundle-price strong {
    font-size: 34px;
    color: #fff;
    font-family: Geomanist, sans-serif;
    font-weight: bold;
    line-height: 1;
  }

  & .card-header p {
    font-family: Roboto, sans-serif;
    font-weight: 200;
    font-size: 15px;
    line-height: 18px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.02em;
    margin-bottom: 8px;
    & strong {
      font-family: Roboto, sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 18px;
      text-align: center;
    }
  }

  & .card-body {
    padding: 0.9375rem 1.25rem 0.625rem 1.25rem;
    margin: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    & p {
      font-family: Roboto, sans-serif;
      font-weight: 200;
      font-size: 16px;
      line-height: 24px;
      color: black;
      text-align: left;
    }

    & .title-section {
      font-family: Roboto, sans-serif;
      color: #f4111b;
      font-weight: 700;
      font-size: 18px;
      line-height: 20px;
      margin-bottom: 0.5rem;
    }
  }

  & .card-footer {
    display: flex;
    justify-content: center;
    margin-top: 3.5rem;
    margin-bottom: 1rem;
    & button {
      font-family: Geomanist, sans-serif;
      font-weight: 700;
      font-size: 15px;
      text-align: center;
      width: 80%;
    }
  }
`;

export const IconsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  justify-items: center;

  & .icon-wrapper {
    background-color: white;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    aspect-ratio: 1;
  }
`;

export const OfferTag = styled.div`
  position: absolute;
  top: -17px;
  height: 35px;
  background: #f4111b;
  border-radius: 0.5rem;
  padding: 0.4rem 0.8rem;
  color: white;
  font-size: 0.875rem;
  font-weight: bold;
  font-family: Geomanist, sans-serif;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 2;
`;

export const ProductsList = styled.ul`
  margin-bottom: 1.5rem;
  list-style: none;
  padding: 0;
  text-align: left;

  & li {
    font-weight: 200;
    list-style: none;
    padding-left: 2.5rem;
    background: url('${CheckIcon.src}') top left no-repeat;
    margin-bottom: 0.95rem;

    & > b,
    & > strong {
      color: #0402fc;
      font-weight: 400;
    }
  }
`;
